var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-loading"},[_c('Loading',{attrs:{"color":"#fff","vertical":"","text-color":"#fff"}},[_vm._v("跳转登录中...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }